import React, {Component} from "react";
import "./space.css";

const styles = {
    btn: {
        border: "none",
        color: "black",
        backgroundColor: "#1bbff9",
        fontSize: "17px",
        width: "120px",
        borderRadius: "15px",
        margin: "5px 10px",
        podding: "10px",
        height: "35px"
    }
}

class Space extends Component {
    render() {

        return (
            <div className="spaceContainer">
                <div id="stars"/>
                <div id="stars2"/>
                <div id="stars3"/>
                <div id="title">
                    <svg viewBox="0 0 800 600" preserveAspectRatio="xMinYMid slice">
                        <g id="comets">
                            <line x1={1185} y1={-15} x2="77.5" y2="1092.5"/>
                            <line x1={854} y1={8} x2={163} y2={699}/>
                            <line x1={573} y1={-33} x2="-49.5" y2="589.5"/>
                            <line x1={271} y1={-33} x2="-60.5" y2="298.5"/>
                            <line x1={463} y1={-76} x2={-102} y2={489}/>
                            <line x1={120} y1={-19} x2={-26} y2={127}/>
                            <line x1={866} y1="174.3" x2="305.6" y2="734.7"/>
                            <line x1={854} y1={462} x2={653} y2={663}/>
                        </g>
                        <g id="rocket">
                            <path
                                d="M445.3,256.3c-47.3-3.5-62.8,27-62.8,27c-18.5,2-24,10-24,10l15.5,12.3c-0.5,15.3,3.5,16.5,3.5,16.5c5.5,7.5,17.8,4.8,17.8,4.8l12.8,17c12-12.5,10.3-25.5,10.3-25.5C450.8,300,445.3,256.3,445.3,256.3zM416.3,297c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8s11.8,5.3,11.8,11.8C428,291.7,422.7,297,416.3,297z"/>
                            <circle/>
                            <polygon points="371.3,338.6 355.7,344.7 363.1,329.7"/>
                        </g>
                    </svg>
                    <h2 className="mainHeader">ESPIRE</h2>
                    <h6 className="subHeader">For Influencers, By Influencers</h6>
                    <button style={styles.btn}><a style={{color: "white", height: "100%", padding: "10px"}}
                                                  href="https://influence.espireads.com/signup">Influencer</a></button>
                    <button style={styles.btn}><a style={{color: "white", height: "100%", padding: "10px"}}
                                                  href="https://influence.espireads.com/advertiser_signup">Advertiser</a>
                    </button>
                </div>
            </div>
        );
    }
}
export default Space;



// WEBPACK FOOTER //
// ./src/components/space/space.js